// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts"
// @generated from file tracker/v1/traffic_source.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { ArchiveTrafficSourceRequest, ArchiveTrafficSourceResponse, CreateTrafficSourceRequest, CreateTrafficSourceResponse, GetTrafficSourceRequest, GetTrafficSourceResponse, ListTrafficSourcesRequest, ListTrafficSourcesResponse, UpdateTrafficSourceRequest, UpdateTrafficSourceResponse } from "./traffic_source_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service tracker.v1.TrafficSourceService
 */
export const TrafficSourceService = {
  typeName: "tracker.v1.TrafficSourceService",
  methods: {
    /**
     * @generated from rpc tracker.v1.TrafficSourceService.ListTrafficSources
     */
    listTrafficSources: {
      name: "ListTrafficSources",
      I: ListTrafficSourcesRequest,
      O: ListTrafficSourcesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.TrafficSourceService.GetTrafficSource
     */
    getTrafficSource: {
      name: "GetTrafficSource",
      I: GetTrafficSourceRequest,
      O: GetTrafficSourceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.TrafficSourceService.CreateTrafficSource
     */
    createTrafficSource: {
      name: "CreateTrafficSource",
      I: CreateTrafficSourceRequest,
      O: CreateTrafficSourceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.TrafficSourceService.UpdateTrafficSource
     */
    updateTrafficSource: {
      name: "UpdateTrafficSource",
      I: UpdateTrafficSourceRequest,
      O: UpdateTrafficSourceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.TrafficSourceService.ArchiveTrafficSource
     */
    archiveTrafficSource: {
      name: "ArchiveTrafficSource",
      I: ArchiveTrafficSourceRequest,
      O: ArchiveTrafficSourceResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

